// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--IGVi_","title":"_9e1425b4d3--title--Eyoyg","date":"_9e1425b4d3--date--_e9Xu"};